import { withBusyButton } from '../../../core/ui/withBusyButton.js';
import { nivelParaComision, porcentajeComisionPorNivel } from '../domain/vendedorNivelRules.js';
import { PRECIO_MAX_ARS } from '../../../core/catalog/precioLimites.js';
import { getCategoriaOpcionesPorSeccion } from '../../../core/catalog/categoriasProducto.js';
import { mensajeErrorStorage } from '../data/storageErrorMsg.js';
import { MLV_ERR_LIMITE_PUBLICACIONES_ACTIVAS } from '../data/productosRepository.js';
import { openModalLimitePublicaciones } from '../../../core/ui/limitePublicacionesModal.js';
import { openModalPublicacionExitoBanners } from '../../../core/ui/publicacionExitoBannersModal.js';
import { mlvTrack } from '../../../core/telemetry/mlvTrack.js';
import { MLV_EVENTS } from '../../../core/telemetry/mlvEvents.js';
import { escapeHtml as esc } from '../../../core/ui/escapeHtml.js';
import { initialsFromUser } from '../../../core/ui/initials.js';
import { mlvNavPng } from '../../../core/ui/mlvPngIcons.js';
import { isServiciosNavVisible } from '../../../core/config/mlvFeatureFlags.js';

const MAX_FOTOS_PRODUCTO = 5;
const MAX_DESCRIPCION_PRODUCTO = 600;

function iconBackPub() {
  return `<svg class="h-6 w-6 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>`;
}
function iconRocketPub() {
  return `<svg class="h-5 w-5 shrink-0 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.281 5.119v4.8a6 6 0 007.281 5.119 14.98 14.98 0 0012.12-6.16 14.98 14.98 0 00-6.16-12.12z" /></svg>`;
}
function iconCameraPlusPub() {
  return `<svg class="w-12 h-12 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0zM16.5 6v.01" /></svg>`;
}
function iconImageSmallPub() {
  return `<svg class="w-8 h-8 text-slate-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3A1.5 1.5 0 001.5 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25z" /></svg>`;
}
function iconNavCompassPub() {
  return mlvNavPng('home');
}
function iconNavPlusPub() {
  return `<svg class="h-6 w-6 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9" /><path stroke-linecap="round" stroke-linejoin="round" d="M12 8.25v7.5M8.25 12h7.5" /></svg>`;
}
function iconNavPersonPub() {
  return mlvNavPng('profile');
}
function iconNavServiciosPub() {
  return mlvNavPng('servicios');
}
function iconChevronDownPub() {
  return `<svg class="w-5 h-5 text-slate-400 pointer-events-none absolute right-3 top-1/2 -translate-y-1/2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>`;
}

export { iconBackPub, iconImageSmallPub, iconNavCompassPub, iconNavPlusPub, iconNavPersonPub, iconNavServiciosPub };

export function createPublicarView({
  render,
  getFirebase,
  repo,
  backToHome,
  onOpenProfile,
  onIrPlanPremium,
  onIrAlCatalogo,
  onOpenServicios,
  showMisPublicaciones,
  /** Navegación: push `mis` antes de abrir (stack Publicar → Mis). */
  beforeOpenMisDesdePublicar,
  /** Navegación: pop al volver de Mis si se usó beforeOpenMisDesdePublicar. */
  afterCloseMisDesdePublicar,
}) {
  return async function publicarView() {
    const { auth } = getFirebase();
    const user = auth.currentUser;
    if (!user) {
      backToHome();
      return;
    }
    const avatarUrl = user.photoURL || '';
    const initials = initialsFromUser(user);

    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <button type="button" id="pub-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">
            ${iconBackPub()}
          </button>
          <h1 class="mlv-screen-title flex-1 text-center font-heading text-lg font-bold tracking-tight text-brand-primary">Publicar producto</h1>
          <div class="flex h-10 w-10 shrink-0 items-center justify-end">
            ${
              avatarUrl
                ? `<img src="${esc(avatarUrl)}" alt="" class="h-10 w-10 rounded-full object-cover ring-2 ring-white shadow-sm" />`
                : `<span class="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-brand-primary to-emerald-900 text-sm font-bold text-white shadow-sm">${esc(initials)}</span>`
            }
          </div>
        </header>

        <main class="max-w-lg mx-auto px-4 pt-5">
          <form id="form-pub" class="space-y-5">
            <section>
              <div class="mb-3 flex items-start justify-between gap-2">
                <div>
                  <h2 class="font-heading text-base font-bold text-slate-900">Fotos del producto</h2>
                  <p class="text-xs text-slate-500 mt-0.5">Subí hasta ${MAX_FOTOS_PRODUCTO} fotos. La primera será la principal.</p>
                </div>
                <span id="pub-photo-count" class="shrink-0 rounded-full bg-brand-muted/80 px-2.5 py-1 text-xs font-semibold text-brand-primary">0 / ${MAX_FOTOS_PRODUCTO}</span>
              </div>
              <div class="flex gap-3">
                <label class="relative flex min-h-[140px] flex-1 cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-300 bg-slate-100/80 px-2 py-4 transition hover:bg-slate-100">
                  <input id="pub-input-fotos" type="file" name="fotos" accept="image/*" multiple class="sr-only" />
                  <span class="pointer-events-none flex flex-col items-center gap-1 text-center">
                    ${iconCameraPlusPub()}
                    <span class="text-sm font-semibold text-slate-600">Agregar foto</span>
                  </span>
                </label>
                <div class="flex h-[140px] w-24 shrink-0 items-center justify-center rounded-2xl bg-slate-200/90">
                  ${iconImageSmallPub()}
                </div>
              </div>
              <div id="pub-previews" class="mt-3 flex flex-wrap gap-2"></div>
            </section>

            <section class="rounded-2xl bg-slate-200/40 p-4 space-y-4">
              <div>
                <label class="mb-1.5 block text-sm font-semibold text-slate-800">Título de la publicación</label>
                <input name="titulo" required autocomplete="off" placeholder="Ej: Bicicleta de paseo vintage" class="w-full rounded-xl border-0 bg-white px-3 py-3 text-slate-900 shadow-sm ring-1 ring-slate-200/80 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-primary/25" />
              </div>
              <div>
                <label class="mb-1.5 block text-sm font-semibold text-slate-800">Precio (ARS)</label>
                <div class="flex rounded-xl bg-white shadow-sm ring-1 ring-slate-200/80 focus-within:ring-2 focus-within:ring-brand-primary/25">
                  <span class="flex items-center px-3 font-semibold text-slate-500">$</span>
                  <input id="pub-precio-input" name="precio" type="number" min="0" max="${PRECIO_MAX_ARS}" step="0.01" required placeholder="0.00" class="min-w-0 flex-1 border-0 bg-transparent py-3 pr-3 text-slate-900 focus:outline-none focus:ring-0" />
                </div>
                <p id="pub-comision-info" class="mt-1 text-[11px] text-slate-600">Máximo $ ${PRECIO_MAX_ARS.toLocaleString('es-AR')} ARS.</p>
              </div>
              <div class="relative">
                <label class="mb-1.5 block text-sm font-semibold text-slate-800">Categoría</label>
                <select name="categoria_id" required class="w-full appearance-none rounded-xl border-0 bg-white py-3 pl-3 pr-10 text-slate-900 shadow-sm ring-1 ring-slate-200/80 focus:outline-none focus:ring-2 focus:ring-brand-primary/25">
                  <option value="" disabled selected>Seleccionar…</option>
                  ${getCategoriaOpcionesPorSeccion()
                    .map(
                      (g) => `
                    <optgroup label="${esc(g.seccionLabel)}">
                      ${g.items
                        .map(
                          (i) =>
                            `<option value="${esc(i.id)}">${esc(i.label)}</option>`
                        )
                        .join('')}
                    </optgroup>`
                    )
                    .join('')}
                </select>
                ${iconChevronDownPub()}
              </div>
              <div>
                <label class="mb-2 block text-sm font-semibold text-slate-800">Condición del ítem</label>
                <input type="hidden" name="estado_producto" id="pub-estado" value="nuevo" />
                <div class="flex rounded-xl bg-slate-300/50 p-1">
                  <button type="button" id="pub-seg-nuevo" class="pub-seg flex-1 rounded-lg bg-white py-2.5 text-sm font-semibold text-brand-primary shadow-sm">Nuevo</button>
                  <button type="button" id="pub-seg-usado" class="pub-seg flex-1 rounded-lg py-2.5 text-sm text-slate-600">Usado</button>
                </div>
              </div>
              <div>
                <div class="mb-1.5 flex items-end justify-between gap-2">
                  <label class="block text-sm font-semibold text-slate-800">Descripción detallada</label>
                  <span id="pub-desc-count" class="text-[11px] font-medium text-slate-400">0 / ${MAX_DESCRIPCION_PRODUCTO}</span>
                </div>
                <textarea id="pub-descripcion" name="descripcion" maxlength="${MAX_DESCRIPCION_PRODUCTO}" rows="5" required class="w-full resize-y rounded-xl border-0 bg-white px-3 py-3 text-slate-900 shadow-sm ring-1 ring-slate-200/80 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-primary/25" placeholder="Contales a tus vecinos por qué este producto es especial…"></textarea>
              </div>
            </section>

            <p id="pub-loading" role="status" aria-live="polite" class="text-sm text-slate-600 min-h-[1.25rem]"></p>
            <div id="pub-notice" class="hidden rounded-xl border p-3 text-sm flex items-center justify-between gap-3">
              <p id="pub-msg" class="m-0"></p>
              <button type="button" id="pub-ok" class="rounded-lg border border-slate-300 px-3 py-1.5 text-sm hover:bg-slate-50">Aceptar</button>
            </div>

            <button type="submit" id="btn-pub-submit" class="btn-async mlv-btn-primary flex w-full items-center justify-center gap-2 rounded-full bg-brand-primary py-3.5 px-6 text-base font-bold text-white shadow-lg transition hover:brightness-95">
              Publicar ahora
              ${iconRocketPub()}
            </button>
            <p class="text-center text-[11px] leading-snug text-slate-500 px-2">
              Al publicar, aceptás los términos de convivencia de la comunidad.
            </p>
            <button type="button" id="pub-mis" class="w-full text-center text-sm font-medium text-slate-600 underline hover:text-slate-900">Mis publicaciones</button>
          </form>
        </main>

        <nav class="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200/90 bg-white/95 px-2 pt-2 backdrop-blur-md" style="padding-bottom:max(0.75rem, env(safe-area-inset-bottom))">
          <div class="mx-auto flex max-w-lg items-center justify-around">
            <button type="button" id="pub-nav-explorar" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconNavCompassPub()}
              <span class="text-[10px] font-medium">Explorar</span>
            </button>
            ${
              isServiciosNavVisible()
                ? `<button type="button" id="pub-nav-servicios" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconNavServiciosPub()}
              <span class="text-[10px] font-medium">Servicios</span>
            </button>`
                : ''
            }
            <button type="button" id="pub-nav-vender" class="mlv-nav-active flex flex-1 flex-col items-center gap-1 rounded-xl bg-brand-primary/10 py-2 text-brand-primary">
              ${iconNavPlusPub()}
              <span class="text-[10px] font-semibold">Vender</span>
            </button>
            <button type="button" id="pub-nav-perfil" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconNavPersonPub()}
              <span class="text-[10px] font-medium">Mi perfil</span>
            </button>
          </div>
        </nav>
      </div>
    `);

    const inputFotos = document.getElementById('pub-input-fotos');
    const countEl = document.getElementById('pub-photo-count');
    const previewsEl = document.getElementById('pub-previews');
    let previewUrls = [];

    function clearPreviewUrls() {
      previewUrls.forEach((u) => URL.revokeObjectURL(u));
      previewUrls = [];
    }

    function updatePhotoUi() {
      const files = inputFotos?.files;
      const n = files?.length || 0;
      if (countEl) countEl.textContent = `${Math.min(n, MAX_FOTOS_PRODUCTO)} / ${MAX_FOTOS_PRODUCTO}`;
      if (!previewsEl) return;
      clearPreviewUrls();
      previewsEl.innerHTML = '';
      if (!files || n === 0) return;
      const cap = Math.min(n, MAX_FOTOS_PRODUCTO);
      for (let i = 0; i < cap; i++) {
        const url = URL.createObjectURL(files[i]);
        previewUrls.push(url);
        const img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.className = 'h-20 w-20 rounded-xl border border-slate-200 object-cover';
        previewsEl.appendChild(img);
      }
    }

    if (inputFotos) {
      inputFotos.addEventListener('change', () => {
        if (inputFotos.files && inputFotos.files.length > MAX_FOTOS_PRODUCTO) {
          const dt = new DataTransfer();
          for (let i = 0; i < MAX_FOTOS_PRODUCTO; i++) dt.items.add(inputFotos.files[i]);
          inputFotos.files = dt.files;
        }
        updatePhotoUi();
      });
    }

    const inputEstado = document.getElementById('pub-estado');
    const btnNuevo = document.getElementById('pub-seg-nuevo');
    const btnUsado = document.getElementById('pub-seg-usado');
    function applyEstadoUi(val) {
      if (!inputEstado || !btnNuevo || !btnUsado) return;
      inputEstado.value = val;
      const on = 'pub-seg flex-1 rounded-lg bg-white py-2.5 text-sm font-semibold text-brand-primary shadow-sm';
      const off = 'pub-seg flex-1 rounded-lg py-2.5 text-sm text-slate-600';
      if (val === 'nuevo') { btnNuevo.className = on; btnUsado.className = off; }
      else { btnUsado.className = on; btnNuevo.className = off; }
    }
    if (btnNuevo) btnNuevo.onclick = () => applyEstadoUi('nuevo');
    if (btnUsado) btnUsado.onclick = () => applyEstadoUi('usado');
    applyEstadoUi('nuevo');

    const taDesc = document.getElementById('pub-descripcion');
    const descCountEl = document.getElementById('pub-desc-count');
    function refreshDescCount() {
      if (!descCountEl || !taDesc) return;
      descCountEl.textContent = `${taDesc.value.length} / ${MAX_DESCRIPCION_PRODUCTO}`;
    }
    taDesc?.addEventListener('input', refreshDescCount);
    refreshDescCount();

    void (async () => {
      try {
        const perfil = await repo.loadUserProfile(user.uid);
        const resumen = repo.resumenNivelVendedor(perfil || {});
        const nivelReal = resumen.nivelEfectivo || 1;
        const primeraPublicacionPendiente = !perfil?.primera_publicacion_en;
        const enTrialNivel5 = Boolean(resumen.enTrialNivel5) || primeraPublicacionPendiente;
        const nivelCom = nivelParaComision({ ventasEnVentana: resumen.ventasEnVentana, enTrialNivel5 });
        const pctCom = porcentajeComisionPorNivel(nivelCom);
        const precioInput = document.getElementById('pub-precio-input');
        const comisionInfo = document.getElementById('pub-comision-info');
        const renderComisionInfo = () => {
          if (!comisionInfo) return;
          const precio = Number(precioInput?.value || 0);
          if (!Number.isFinite(precio) || precio <= 0) {
            comisionInfo.textContent = `Máximo $ ${PRECIO_MAX_ARS.toLocaleString('es-AR')} ARS.`;
            return;
          }
          const monto = Math.round(((precio * pctCom) / 100) * 100) / 100;
          if (enTrialNivel5) {
            const motivo = primeraPublicacionPendiente
              ? 'Al publicar tu primer producto se activa el beneficio Premium de 30 días'
              : 'Por el beneficio Premium de 30 días';
            comisionInfo.innerHTML = `${motivo}: comisión <strong>nivel 5</strong> → <strong>${pctCom}%</strong> (<strong>$ ${esc(monto.toLocaleString('es-AR', { maximumFractionDigits: 2 }))}</strong>). Tu nivel real es <strong>${nivelReal}</strong>.`;
            return;
          }
          comisionInfo.innerHTML = `Como sos nivel ${nivelCom}, la comisión de la venta es del <strong>${pctCom}%</strong> (<strong>$ ${esc(monto.toLocaleString('es-AR', { maximumFractionDigits: 2 }))}</strong>).`;
        };
        if (precioInput) precioInput.addEventListener('input', renderComisionInfo);
        renderComisionInfo();
      } catch (e) { console.error(e); }
    })();

    document.getElementById('pub-back').onclick = () => backToHome();
    document.getElementById('pub-mis').onclick = async () => {
      const btnMis = document.getElementById('pub-mis');
      await withBusyButton(btnMis, async () => {
        const sincronizaHistorial = typeof beforeOpenMisDesdePublicar === 'function';
        if (sincronizaHistorial) beforeOpenMisDesdePublicar();
        await showMisPublicaciones(user.uid, {
          onBack: sincronizaHistorial
            ? () =>
                typeof afterCloseMisDesdePublicar === 'function'
                  ? afterCloseMisDesdePublicar()
                  : window.history.back()
            : () => publicarView(),
        });
      }, { labelBusy: 'Abriendo…' });
    };
    document.getElementById('pub-nav-explorar').onclick = () => onIrAlCatalogo?.();
    document.getElementById('pub-nav-servicios')?.addEventListener('click', () => onOpenServicios?.());
    const pubNavVender = document.getElementById('pub-nav-vender');
    if (pubNavVender) pubNavVender.onclick = () => publicarView();
    document.getElementById('pub-nav-perfil').onclick = () => onOpenProfile?.();

    document.getElementById('form-pub').onsubmit = async (e) => {
      e.preventDefault();
      const loading = document.getElementById('pub-loading');
      const notice = document.getElementById('pub-notice');
      const msg = document.getElementById('pub-msg');
      const btnOk = document.getElementById('pub-ok');
      const setLoading = (text) => { loading.textContent = text || ''; };
      const setPubNotice = (state, text) => {
        notice.classList.remove('hidden', 'border-red-200', 'bg-red-50', 'text-red-700', 'border-green-200', 'bg-green-50', 'text-green-700');
        if (state === 'error') notice.classList.add('border-red-200', 'bg-red-50', 'text-red-700');
        else notice.classList.add('border-green-200', 'bg-green-50', 'text-green-700');
        msg.textContent = text;
      };
      const clearNotice = () => { notice.classList.add('hidden'); msg.textContent = ''; };
      btnOk.onclick = () => clearNotice();
      setLoading('');
      clearNotice();
      const uid = getFirebase().auth.currentUser.uid;
      const fd = new FormData(e.target);
      const titulo = fd.get('titulo');
      const precio = Number(fd.get('precio'));
      if (!Number.isFinite(precio) || precio < 0) {
        setPubNotice('error', 'Indicá un precio (número mayor o igual a 0).');
        return;
      }
      if (precio > PRECIO_MAX_ARS) {
        setPubNotice(
          'error',
          `El precio no puede superar $ ${PRECIO_MAX_ARS.toLocaleString('es-AR')} ARS (límite del marketplace).`
        );
        return;
      }
      const categoria_id = String(fd.get('categoria_id') || 'general');
      const estado_producto = String(fd.get('estado_producto') || 'usado');
      const descripcion = String(fd.get('descripcion') || '').trim();
      if (descripcion.length > MAX_DESCRIPCION_PRODUCTO) {
        setPubNotice(
          'error',
          `La descripción puede tener hasta ${MAX_DESCRIPCION_PRODUCTO} caracteres.`
        );
        return;
      }
      const inputFotosPub = document.getElementById('pub-input-fotos');
      const files = Array.from(inputFotosPub?.files || []).filter((f) => f && f.size);
      if (files.length === 0) {
        setPubNotice('error', 'Agregá al menos una foto del producto.');
        return;
      }
      if (files.length > MAX_FOTOS_PRODUCTO) {
        setPubNotice('error', `Máximo ${MAX_FOTOS_PRODUCTO} fotos por publicación.`);
        return;
      }
      const submitBtn = document.getElementById('btn-pub-submit');
      const btnMis = document.getElementById('pub-mis');
      setLoading('Publicando…');
      mlvTrack(MLV_EVENTS.PUBLICAR_INICIADO, {
        categoria_id,
        estado_producto,
        fotos: files.length,
      });
      await withBusyButton(submitBtn, async () => {
        if (btnMis) btnMis.disabled = true;
        try {
          await repo.publicarProducto(uid, { titulo, precio, categoria_id, estado_producto, descripcion, files });
          clearNotice();
          try {
            await openModalPublicacionExitoBanners();
          } catch (modalErr) {
            console.error(modalErr);
          }
          mlvTrack(MLV_EVENTS.PUBLICAR_OK, {
            vio_modal_upsell: true,
            categoria_id,
            estado_producto,
            precio,
            fotos: files.length,
          });
          e.target.reset();
          applyEstadoUi('nuevo');
          updatePhotoUi();
          refreshDescCount();
        } catch (err) {
          console.error(err);
          mlvTrack(MLV_EVENTS.PUBLICAR_FAIL, {
            code: String(err?.code || 'unknown'),
            categoria_id,
          });
          if (err?.code === MLV_ERR_LIMITE_PUBLICACIONES_ACTIVAS) {
            clearNotice();
            await openModalLimitePublicaciones({
              esPremium: Boolean(err.esPremium),
              limiteActivas: Number(err.limiteActivas) || 3,
              onActivarPremium: () =>
                (typeof onIrPlanPremium === 'function' ? onIrPlanPremium() : onOpenProfile?.()),
              onIrMisPublicaciones: async () => {
                const sincronizaHistorial = typeof beforeOpenMisDesdePublicar === 'function';
                if (sincronizaHistorial) beforeOpenMisDesdePublicar();
                await showMisPublicaciones(uid, {
                  onBack: sincronizaHistorial
                    ? () =>
                        typeof afterCloseMisDesdePublicar === 'function'
                          ? afterCloseMisDesdePublicar()
                          : window.history.back()
                    : () => publicarView(),
                });
              },
            });
          } else {
            const message = err?.code?.startsWith?.('storage/')
              ? mensajeErrorStorage(err)
              : err.message || 'Error al publicar.';
            setPubNotice('error', message);
          }
        } finally {
          setLoading('');
          if (btnMis) btnMis.disabled = false;
        }
      });
    };
  };
}
